import styled from 'styled-components';

export const Container = styled.div`

    margin: ${ ({ margin }) => margin };
    
    .react-tel-input > input {
        :focus-visible {
            box-shadow: 0px 0px 1px 1px ${ ({ error, theme: { dangerColor, primaryColor } }) => !!error ? dangerColor : primaryColor } !important;
            outline: unset;
        }
    }

    .selected-flag {
        :focus-visible {
            box-shadow: 0px 0px 1px 1px ${ ({ error, theme: { dangerColor, primaryColor } }) => !!error ? dangerColor : primaryColor } !important;
            outline: unset;
        }
    }

    .selected-flag.open {
        box-shadow: 0px 0px 1px 1px ${ ({ error, theme: { dangerColor, primaryColor } }) => !!error ? dangerColor : primaryColor } !important;
        outline: unset;
    }
`;
